// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForwardedFrom_root__BFFWo {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}

.ForwardedFrom_label__agZuV {
  color: #8E8E93;
  font-size: 12px;
  font-weight: 400;
  margin-right: 2px;
}

.ForwardedFrom_profile__\\+\\+nq0 {
  color: #4778EE;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ForwardedFrom/ForwardedFrom.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;EAEA,eAAA;EAEA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AADF","sourcesContent":[".root {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  text-decoration: none;\n  //user-select: none;\n  cursor: pointer;\n\n  white-space: nowrap;\n}\n\n.label {\n  color: #8E8E93;\n  font-size: 12px;\n  font-weight: 400;\n  margin-right: 2px;\n}\n\n.profile {\n  color: #4778EE;\n  font-size: 12px;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ForwardedFrom_root__BFFWo`,
	"label": `ForwardedFrom_label__agZuV`,
	"profile": `ForwardedFrom_profile__++nq0`
};
export default ___CSS_LOADER_EXPORT___;
